import React, { ChangeEvent, KeyboardEvent } from 'react';
import { Search, Clear } from '@material-ui/icons';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';

import { useStyles } from './styles';
import { SearchBarProps } from './types';

export const SearchBar: React.FC<SearchBarProps> = ({
  label = 'Buscar',
  disabled,
  searchTerm,
  onSearch,
  onClearSearch
}) => {
  const classes = useStyles();

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onSearch(value);
  };

  const handleSearch = () => {
    onSearch(searchTerm);
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleClearSearch = () => {
    onClearSearch();
  };

  return (
    <div>
      <TextField
        className={classes.root}
        label={label}
        value={searchTerm ?? ''}
        onChange={handleSearchChange}
        onKeyDown={handleKeyPress}
        disabled={disabled}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {searchTerm && (
                <IconButton className={classes.button} onClick={handleClearSearch} disabled={disabled}>
                  <Clear />
                </IconButton>
              )}
              <IconButton className={classes.button} onClick={handleSearch} disabled={disabled}>
                <Search />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    </div>
  );
};
